<template>
  <div class="g-wrap">
    <div class="page-project-sub">
      <div class="g-sub-top">
        <!-- 面包屑 -->
        <el-breadcrumb class="cus-breadcrumb-pro" separator="/">
          <el-breadcrumb-item :to="{ path: $route.query.projectType == 2 ? '/project/project-plan' : '/project-list' }">
            <span class="pro-menu">{{$route.query.projectType == 2  ? '展陈项目': '项目协作'}}</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <span style="cursor: pointer;" class="ell" @click="clickTop(nowProObj)">{{nowProObj.projectName}}</span>
            <!-- 头部菜单面板 -->
            <!-- <el-popover class="pop-wrap" v-model="showTop" placement="bottom-start" trigger="click">
              <div class="pop-wrap-top m-search-wrap">
                <ul>
                  <li v-for="(item, index) in topProList" :key="index" :class="{'active': item.projectId === topProActive.projectId}" @click="clickTop(item)">
                    <h2 class="ell">{{item.projectName}}</h2>
                    <i class="el-icon el-icon-check" v-if="item.projectId === topProActive.projectId"></i>
                  </li>
                </ul>
              </div>
              <span class="top-menu-current" slot="reference">
                {{topProActive.projectName}}&nbsp;
                <i class="el-icon el-icon-arrow-down"></i>
              </span>
            </el-popover> -->
          </el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 导航 -->
        <cmp-header-sub :tabList="tabs" :activeTab="currentTab" :pageType="`project`" :callFun="changeTab"></cmp-header-sub>

        <!-- 操作 -->
        <div class="menu-sub-right">
          <label class="mr-20" v-if="menuRight">
            <el-popover class="pop-wrap" v-model="showViewType" placement="bottom-end" trigger="click">
              <div class="operate-box">
                <!-- 菜单悬浮面板 -->
                <div class="m-panel">
                  <h3 @click="toggleViewType" :class="{'active': $store.state.app.isPanelType}">看板模式</h3>
                  <h3 @click="toggleViewType" :class="{'active': !$store.state.app.isPanelType}">列表模式</h3>
                </div>
              </div>
              <span class="m-btn default" slot="reference">
                {{$store.state.app.isPanelType ? '看板模式' : '列表模式'}}
                <i class="el-icon el-icon-arrow-down"></i>
              </span>
            </el-popover>
          </label>

          <!-- 成员 -->
          <el-popover class="pop-wrap mr-20" placement="bottom-end" v-model="addLeaderPopover" trigger="click">
            <!-- 搜索负责人列表 悬浮面板 -->
            <cmp-leader-list ref="cmpLeaderList" :callFun="handleChooseAdd" :isSinglePro="false"></cmp-leader-list>

            <label class="g-pointer" slot="reference" @click="showLeaderList">
              <svg-icon icon-class="chengyuan" class-name="icon-chengyuan icon-common" style="font-size: 20px;" />
              <span class="count">{{count}}</span>
            </label>
          </el-popover>

          <!-- 菜单 -->
          <el-dropdown trigger="click" @command="handleOperate">
            <span>
              <svg-icon icon-class="more" class-name="icon-common g-pointer" style="font-size: 18px;" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">项目设置</el-dropdown-item>
              <!-- <el-dropdown-item command="2">项目归档</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="sub-content">
        <div class="sub-content-wrap">
          <!-- <router-view/> -->
          <component :is="currentTabCmp" ref="subpage"></component>
        </div>
      </div>

      <!-- 项目设置 -->
      <cmp-dialog-pro-setting ref="dialogProSetting" @hasUpdatePro="changeProName"></cmp-dialog-pro-setting>
    </div>
  </div>
</template>

<script>
import cmpDialogProSetting from './dialog/dialog-pro-setting' // 项目设置
import cmpHeaderSub from '@cmp/header-sub'
import cmpLeaderList from '@cmp/leader-list'
import taskProject from './task'
import taskListProject from './task-list'
import exhibitsProject from './exhibits'
import fileProject from './file'
import discussProject from './discuss'
import statisticProject from './statistic'
export default {
  components: {
    cmpDialogProSetting,
    cmpHeaderSub,
    cmpLeaderList,
    taskProject,
    taskListProject,
    exhibitsProject,
    fileProject,
    discussProject,
    statisticProject
  },
  data() {
    return {
      showPanel: true, // 显示面板视图
      dialogVisible: false,
      nowProObj: {},
      addLeaderPopover: false, // 添加成员面板
      menuRight: this.$route.query.type === 'task' ? true : false,
      // 顶部项目选择
      topProActive: {
        projectName: this.$route.query.projectName,
        projectId: this.$route.query.projectId
      },
      count: '', // 成员人数
      // 项目列表
      topProList: [],
      currentTab: this.$route.query.type,
      // currentTab: 'task',
      tabs: [],
      showTop: false, // 顶部项目选择面板
      // popMenu: false,  // 显示菜单面板
      key: '',
      showViewType: false, // 显示看板模式弹窗
      dialogData: [
        {
          name: '标准项目'
        }
      ]
    }
  },
  computed: {
    currentTabCmp() {
      if (
        this.$route.query.type === 'task' &&
        !this.$store.state.app.isPanelType
      ) {
        return 'taskListProject' // 列表视图
      }
      return this.$route.query.type && this.$route.query.type + 'Project'
    }
  },
  watch: {
    $route(to) {
      // if (to.path !== '/project/sub') return
      let type = to.query.type
      if (type === 'task') {
        this.menuRight = true
      } else {
        this.menuRight = false
      }
    }
  },
  // computed: {
  //   currentTab() {
  //     if (this.$route.path !== '/project/sub') return
  //     return this.$route.query.type
  //   },
  //   currentTabCmp() {
  //     if (this.currentTab === 'task' && !this.$store.state.app.isPanelType) {
  //       this.menuRight = true
  //       return 'taskListProject' // 列表视图
  //     } else if (
  //       this.currentTab === 'task' &&
  //       this.$store.state.app.isPanelType
  //     ) {
  //       this.menuRight = true
  //     } else {
  //       this.menuRight = false
  //     }
  //     return this.currentTab && this.currentTab + 'Project'
  //   }
  // },
  methods: {
    // 切换视图类型
    toggleViewType() {
      this.showViewType = false
      this.$store.dispatch('ToggleViewType')
    },
    // 項目列表
    getProList() {
      this.$http
        .get('/project/getProjectList', {
          type: this.$route.query.projectType
        })
        .then(res => {
          if (res.success) {
            this.topProList = res.result
            this.nowProObj = this.topProList.filter((item, index) => {
              return item.projectId == this.topProActive.projectId
            })[0]
            console.log(this.nowProObj)
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 项目详情
    getDetailData() {
      this.tabs = []
      this.$http
        .post('/project/getProjectInfo', {
          projectId: this.$route.query.projectId
        })
        .then(res => {
          if (res.success) {
            this.count = res.result.ext1

            if (this.$route.query.projectType == 1) {
              res.result.blocks.forEach(item => {
                if (item.blockName == '展陈流程') {
                  this.tabs.push({
                    name: '项目流程',
                    path: item.path
                  })
                } else if (item.blockName == '展陈资料') {
                  this.tabs.push({
                    name: '项目资料',
                    path: item.path
                  })
                } else if (item.blockName == '数据统计') {
                  this.tabs.push({
                    name: '数据统计',
                    path: item.path
                  })
                }
              })
            } else {
              res.result.blocks.forEach(item => {
                if (item.blockName != '在线讨论') {
                  this.tabs.push({
                    name: item.blockName,
                    path: item.path
                  })
                }
              })

            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 选择项目
    clickTop(item) {
      this.topProActive = item
      this.showTop = false
      this.$router.replace({
        path: this.$route.path,
        query: {
          projectId: item.projectId,
          projectName: item.projectName,
          type: 'task',
          projectType: this.$route.query.projectType
        }
      })
      this.getDetailData()
      if (this.$route.query.type === 'discuss') {
        this.$refs.subpage.getDataList('changePro')
      } else {
        this.$refs.subpage.getDataList()
      }
    },
    // 点击菜单面板
    handleOperate(type) {
      // this.popMenu = false
      if (type === '1') {
        // 项目设置
        this.$refs.dialogProSetting.init('edit', this.$route.query.projectId)
      } else if (type === '2') {
        // 项目归档
        this.$http
          .post('/project/projectArchive', {
            projectId: this.$route.query.projectId
          })
          .then(res => {
            if (res.success) {
              this.$message.success(res.message || '操作成功')
            } else {
              this.$message.error(res.message)
            }
          })
      }
    },
    changeTab(path) {
      this.$router.push({
        path: '/project/sub',
        query: {
          type: path,
          projectId: this.$route.query.projectId,
          projectName: this.$route.query.projectName,
          projectType: this.$route.query.projectType
        }
      })
    },
    // 显示成员列表
    showLeaderList() {
      this.$refs.cmpLeaderList.showList()
    },
    // 项目人员新增
    handleChooseAdd(item) {
      this.addLeaderPopover = false

      this.$http
        .post('/projectUser/addProjectUser', {
          userId: item.userId, //	用户ID
          projectId: this.$route.query.projectId, //	项目ID
          userStatus: '' //	用户状态
        })
        .then(res => {
          if (res.success) {
            this.getDetailData()
            this.$message.success('添加成功')
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 修改项目名
    changeProName(name) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          type: this.$route.query.type,
          projectId: this.$route.query.projectId,
          projectName: name
        }
      })

      this.topProActive.projectName = name
      this.topProList.forEach(item => {
        if (item.projectId === this.topProActive.projectId) {
          item.projectName = name
        }
      })
    }
  },
  created() {
    this.getProList()
    this.getDetailData()
  }
}
</script>

<style lang="scss" scoped>
.g-sub-top {
  /deep/ .el-breadcrumb {
    font-size: 16px;
    margin-bottom: 0;
  }
  /deep/ .el-breadcrumb__inner.is-link {
    font-weight: normal;
  }
  .pro-menu {
    color: $color5 !important;
    cursor: pointer !important;
  }
  .top-menu-current {
    color: $primary !important;
    cursor: pointer !important;
  }
  .menu-sub-right {
    width: 200px;
    text-align: right;
    .count {
      position: relative;
      top: -2px;
      margin-left: 5px;
      font-size: 14px;
      color: $color5;
    }
    .icon-menu-sub {
      display: inline-block;
      width: 20px;
      height: 20px;
    }
    .pop-wrap {
      position: relative;
      display: inline-block;
      cursor: pointer;
    }
  }
}
.pop-wrap-top.m-search-wrap {
  width: 200px;
  padding: 15px 0;
  ul {
    padding-right: 0;
    li {
      padding: 0 30px;
      margin-top: 0;
      line-height: 46px;
      h2 {
        font-weight: normal;
      }
      &:hover {
        color: $primary;
        background-color: $color4;
      }
      &.active h2 {
        font-weight: bold;
      }
    }
  }
}
.pop-wrap-search.m-search-wrap {
  width: 260px;
}
</style>
